import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const CreateProgramTemplateWrapper = styled.div`
  padding-top: 6px;

  .separator-space {
    margin: 16px 0px;
  }

  .form-header {
    padding-left: 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }
`;

export const ConfirmMessageWrapper = styled.div`
  .confirm-message {
    line-height: 22px;
    color: ${COLORS.cirrus_black10};
  }
`;
